module.exports = __webpack_public_path__ + "img/logout_icon.c504425c.svg";